/**
 * Path to resume after sign-in, including the query string.
 * Login state stores a location; using pathname alone drops `?next=`.
 * @param {{ pathname?: string, search?: string }|null|undefined} from
 * @returns {string}
 */
export function authReturnPath(from) {
  if (!from?.pathname) return "/";
  return `${from.pathname}${from.search || ""}`;
}
